import {formatDateNoTime, shortFormatDateNoTime} from "../../utils/friendlyDate";
import {ColProps, TableContentProps} from "./tableTypes";
import {getStyle} from "./getStyle";

const TableContent = ({ data, cols, reFetch, onRowClick = (row: any) => null }: TableContentProps) => {
    const getValue = (row: any, col: ColProps) => {
        if(col.render) {
            return col.render(row[col.key], row, reFetch);
        }
        if(col.type === 'date') {
            const date = new Date(row[col.key]);
            return formatDateNoTime(date);
        } else if(col.type === 'number') {
            return row[col.key] ? Math.floor(row[col.key]).toLocaleString() : 0;
        } else if(col.type === 'usd') {
            return row[col.key] ? `$${Math.floor(row[col.key]).toLocaleString()}` : '$0';
        } else if(col.type === 'percent') {
            return row[col.key] ? `%${Math.floor(row[col.key]).toLocaleString()}` : '%0';
        }
        return row[col.key] || 0;
    }

    return (
        <div className="table-body">
            {data.map((row: any, rowIndex: number) => {
                return (
                    <div key={`table-body-row-${rowIndex}`} className="table-row-container">
                        <div className="table-row" onClick={() => onRowClick(row)}>
                            {cols.map(col => {
                                return (
                                    <div key={`table-row-col-${rowIndex}-${col.key}`} className="table-cell" style={getStyle(col)}>
                                        {getValue(row, col)}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )
            })}
        </div>
    );
}

export default TableContent;